import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Breadcrumbs from '@/components/Breadcrumbs';
import Link from '@/components/Link';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PageTitleLink from '@/components/PageTitleLink';
import { ROUTE_PATH as ROUTE_PARKING_LEVEL_THREE_WHITELIST_ADD_PATH } from '@/features/parkingLevelThreeWhitelistAddPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_TOWER_STOP_LIST_PATH } from '@/features/parkingTowerStopListPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_WHITELIST_PATH } from '@/features/parkingWhitelistPage/consts';

import Table from './Table';

class ParkingLevelThreeWhitelistPage extends Component {
  static propTypes = {
    error: PropTypes.any,
    parkingLevelThreeWhitelistIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool.isRequired,
    totalCount: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const {
      error,
      parkingLevelThreeWhitelistIds,
      isLoading,
      totalCount,
      classes,
    } = this.props;

    return (
      <Page>
        <PageHeader borderBottom gutterBottom={false}>
          <Breadcrumbs />
          <PageTitle
            style={{
              marginBottom: 30,
              display: 'flex',
              gap: 20,
              justifyContent: 'start',
              placeItems: 'end',
              flexWrap: 'wrap',
            }}
            gutterBottom={false}
          >
            <PageTitleLink
              style={{ margin: 0 }}
              to={ROUTE_PARKING_WHITELIST_PATH}
            >
              Whitelist Тимирязева
            </PageTitleLink>
            <PageTitleLink
              to={ROUTE_PARKING_TOWER_STOP_LIST_PATH}
              style={{ margin: 0 }}
            >
              Stoplist Tower
            </PageTitleLink>
            <PageTitle
              to={ROUTE_PARKING_TOWER_STOP_LIST_PATH}
              style={{ margin: 0 }}
            >
              Whitelist P3
            </PageTitle>
          </PageTitle>
        </PageHeader>

        <PageContent className={classes.tableBlock}>
          <div className={classes.buttonsWrapper}>
            <div className={classes.reportWrapper}>
              <Link to={ROUTE_PARKING_LEVEL_THREE_WHITELIST_ADD_PATH}>
                <Button
                  variant="outlined"
                  color="default"
                  size="small"
                  className={classes.button}
                >
                  Добавить пользователей
                </Button>
              </Link>
            </div>
          </div>
          <Table
            error={error}
            items={parkingLevelThreeWhitelistIds}
            isLoading={isLoading}
            totalCount={totalCount}
          />
        </PageContent>
      </Page>
    );
  }
}

export default ParkingLevelThreeWhitelistPage;
